import React from "react"
import DemoGraphic from "./Demo.png"
import Wrapper from "@components/Wrapper"
import WrapperInner from "@components/WrapperInner"
import styles from "./ContactSection.module.scss"
import { OutboundLink } from "@assertiv/assertiv-gatsby-plugin-google-gtag"
import AnchorButton from "@components/CTAAnchorButton"

export default class ContactSection extends React.Component {
  constructor() {
    super()
  }

  render() {
    return (
      <section className="container-fluid bg-xl-light-gray">
          <div className="row ml-0 mr-0">
              <Wrapper className={"w-100 text-left"} gap="outer">
                  <div className="row bg-white justify-content-center pt-10">
                      <div className={"col-auto col-lg-10 m-lg-2 " + styles.contactParent}>
                          <h3
                          className={
                              styles.title +
                              " proxima-nova--extra-bold text-secondary fs-30pt fs-lg-42pt pb-5"
                          }
                          >
                              Jump in the Fast Lane with an EngineID Demonstration
                          </h3>
                          <div className={styles.contactRow + " row bg-white"}>
                              <div className={ styles.topTextBody + " col-12"}>
                                  <img alt="EngineID Demo" className={styles.tabletImage} src={DemoGraphic} />
                                  <p>
                                    Learning how to use any new product can be a daunting experience. That’s why we offer complimentary sessions with our expert team to fast 
                                    track this process.
                                  </p>
                                  <p>
                                    We want you to improve cyber security, speed up staff onboarding and access applications easier, as efficiently as possible. 
                                    Our live demos are a great opportunity to understand how EngineID works, and how it can make your life easier. Our demonstrations will be tailored to 
                                    suit your needs.
                                  </p>
                                  <p>
                                    Rest assured that our demos are 100% obligation free. They will be delivered by technical staff excited to show you how to get the most out of the 
                                    solution. All demos are online and can be scheduled in at a time that works for you.
                                  </p>
                                  <div className={styles.centerButton}>
                                    <AnchorButton
                                      target="_blank"
                                      href="https://outlook.office365.com/owa/calendar/EngineID@engineid.com/bookings/"
                                      content="Book in for a demo and fast track your EngineID experience!"
                                      className={styles.button}
                                    />
                                  </div> 
                              </div>
                          </div>
                      </div>
                  </div>
              </Wrapper>
          </div>
      </section>
    )
  }
}
